export enum RequirementsListItemStatus {
	NOT_UPLOADED = 'not_uploaded',
	WAITING_FOR_APPROVE = 'waiting_for_approve',
	APPROVED = 'approved',
}
